$(function () {
    // Products carousel
    window.defaultProductsCarouselOptions = {
        infinite:       true,
        slidesToShow:   5,
        slidesToScroll: 5,
        swipe:          false,
        prevArrow:      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="ri-arrow-left-s-line align-baseline"></i></button>',
        nextArrow:      '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="ri-arrow-right-s-line align-baseline"></i></button>',
        responsive:     [
            {
                breakpoint: 1400,
                settings:   {
                    slidesToShow:   4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 980,
                settings:   {
                    slidesToShow:   3,
                    slidesToScroll: 3,
                    swipe:          true,
                },
            },
            {
                breakpoint: 668,
                settings:   {
                    slidesToShow:   2,
                    slidesToScroll: 2,
                    swipe:          true,
                },
            },
            {
                breakpoint: 435,
                settings:   {
                    slidesToShow:   1,
                    slidesToScroll: 1,
                    swipe:          true,
                },
            },
        ],
    };

    // Banners carousel
    $(".slider").slick({
        infinite:       true,
        slidesToShow:   1,
        slidesToScroll: 1,
        autoplay:       true,
        autoplaySpeed:  2000,
        dots:           true,
        prevArrow:      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="ri-arrow-left-s-line"></i></button>',
        nextArrow:      '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="ri-arrow-right-s-line"></i></button>',
    });
});
